import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=4b741276&"
import script from "./EntityView.vue?vue&type=script&lang=ts&"
export * from "./EntityView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports